import { queryOptions, useQuery } from '@tanstack/react-query';

import { apiResourceSchema } from '../common/schemas';
import { fetchJson } from '../fetch';
import { QueryKeys } from '../keys';
import { invoiceHistorySchema } from './schemas';

export const invoiceHistoryQueryOptions = (id: number) =>
  queryOptions({
    queryKey: QueryKeys.invoices.show.history(id),
    queryFn: async () => {
      const { data: invoiceHistory } = await fetchJson(`/invoices/${id}/history`, {
        schema: apiResourceSchema(invoiceHistorySchema),
      });

      return invoiceHistory;
    },
    staleTime: 60 * 1000,
  });

export const useInvoiceHistory = (id: number) => {
  return useQuery(invoiceHistoryQueryOptions(id));
};
